module.exports=function(scope){ return `<!--  Liveness failed -->
{
    "data": {},
    "meta": {
        "code": 400,
        "message": "A FaceMap could not be generated.",
        "ok": false,
        "m": {
            "totalDurationInMS": 3
        }
    }
}
`};


// WEBPACK FOOTER //
// ./src/resources/code/restsdk-v2/response/failure/liveness.json.tpl